
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    PUTTBDFIVEPOINTS_ACTION,
    ALL_PUTTBDFIVEPOINTS,
    ADD_PUTTBDFIVEPOINTS,
    ALL_PUTTBDFIVEPUTTS,
    ADD_PUTTBDFIVEPUTTS,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Putt broadie Drill 5FT Actions
 */

    export const stdBDFivePoints = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:PUTTBDFIVEPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentputtbdfivepoint', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data;
                
                dispatch({ type: ALL_PUTTBDFIVEPOINTS, payload: alldata.data }); 
                return Promise.resolve(alldata);
            });
        
        }
    }

    export const addBDFivePoints = (student, startdate, enddate, data, sepmore) =>{
        
        var payload={
            "startdate":startdate,
            "enddate":enddate,
            "totval":1,
            "student":student,
            "shtot_1":sepmore,
        }
        

        for (let i = 0; i<sepmore; i++) {   
           
            var putdate='puttdate_'+i;            
            var putdateval=data.target[putdate].value;
            var putpoint='noputt_'+i;            
            var putpointval=data.target[putpoint].value;                   
            
            var adval=i+1;            
            var dateadd='puttdate_1_'+adval;  
            var puttadd='noputt_1_'+adval;             
           
            payload[dateadd]=putdateval;
            payload[puttadd]=putpointval;          
    
        }        

        return (dispatch) => { 
            dispatch({ type:PUTTBDFIVEPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addputtbdfivepoint', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                   
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PUTTBDFIVEPOINTS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const stdBDFivePutts = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:PUTTBDFIVEPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentputtbdfiveputt', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data;
                
                dispatch({ type: ALL_PUTTBDFIVEPUTTS, payload: alldata.data }); 
                return Promise.resolve(alldata);
            });
        
        }
    }

    export const addBDFivePutts = (student, startdate, enddate, data, sepmore) =>{
        
        var payload={
            "startdate":startdate,
            "enddate":enddate,
            "totval":1,
            "student":student,
            "shtot_1":sepmore,
        }
        

        for (let i = 0; i<sepmore; i++) {   
           
            var putdate='puttdate_'+i;            
            var putdateval=data.target[putdate].value;
            var putpoint='noputt_'+i;            
            var putpointval=data.target[putpoint].value;                   
            
            var adval=i+1;            
            var dateadd='puttdate_1_'+adval;  
            var puttadd='noputt_1_'+adval;             
           
            payload[dateadd]=putdateval;
            payload[puttadd]=putpointval;          
    
        }        

        return (dispatch) => { 
            dispatch({ type:PUTTBDFIVEPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addputtbdfiveputt', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                   
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PUTTBDFIVEPUTTS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


